module.exports = __webpack_public_path__ + "img/linked-in.72676299.svg";